import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface FormTextareaSignature {
  Element: HTMLDivElement;
  Args: {
    id: string;
    label: string;
    placeholder?: string;
    value?: string;
    required?: boolean;
    onInput?: (e: Event) => void;
    class?: string;
    rows?: number;
  };
}

export default class FormTextarea extends Component<FormTextareaSignature> {
  @tracked isFocused = false;

  get placeholder() {
    return this.args.placeholder || this.args.label;
  }

  get textareaClass() {
    const baseClass =
      'rounded-2xl bg-white/5 border border-white/10 px-4 py-3 min-h-[120px] outline-none w-full';
    return this.args.class ? `${baseClass} ${this.args.class}` : baseClass;
  }

  get containerClass() {
    return this.isFocused ? 'sci-input-wrapper is-focused' : 'sci-input-wrapper';
  }

  @action
  handleBlur() {
    this.isFocused = false;
  }

  @action
  handleFocus() {
    this.isFocused = true;
  }

  <template>
    <div ...attributes>
      <label for={{@id}} class="sr-only">{{@label}}</label>
      <div class={{this.containerClass}}>
        <div class="sci-input-container max-h-[123px]">
          <textarea
            id={{@id}}
            required={{@required}}
            class="sci-input {{this.textareaClass}}"
            placeholder={{this.placeholder}}
            rows={{@rows}}
            value={{@value}}
            {{on "input" @onInput}}
            {{on "focus" this.handleFocus}}
            {{on "blur" this.handleBlur}}
          ></textarea>
        </div>
      </div>
    </div>
  </template>
}
